<template>
  <el-dialog title="Lieferant ein Produkt zuweisen" :visible="show" @close="close"
    width="30%"
  >
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <div class="form-group has-label">
            <label>Produkt</label>
            <multiselect v-model="product"
              @change="productSelected"
              :options="products"
              track-by="id"
              label="name"
            />
          </div>
          <fg-input label="Preis"
            type="text"
            :value="price"
            @input="price = $event"
            :error="valErrors['price'] ? valErrors['price'][0] : null"
          />
          <fg-input label="EAN / Artikelnummer"
            type="text"
            v-model="referenznummer"
            :error="valErrors['referenznummer'] ? valErrors['referenznummer'][0] : null"
          />
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary"
              :disabled="! canSubmit"
            >
              Zuweisen
            </button>
            <button class="btn btn-fill btn-default"
              @click.prevent="close"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import priceWatcher from 'src/pages/Products/price-watcher'

export default {
  props: ['show', 'products', 'valErrors'],
  components: { [Dialog.name]: Dialog },
  mixins: [priceWatcher],
  data () {
    return {
      product: null,
      supplierPrice: '',
      referenznummer: null
    }
  },
  computed: {
    canSubmit () {
      return this.product && this.supplierPrice
    }
  },
  methods: {
    getPrice () {
      return this.supplierPrice
    },
    setPrice (price) {
      this.supplierPrice = price
    },
    submit () {
      this.$emit('assignProduct', {
        product_id: this.product ? this.product.id : null,
        price: this.supplierPrice,
        referenznummer: this.referenznummer
      })
    },
    productSelected (product) {
      this.referenznummer = product ? product.referenznummer : null
    },
    close () {
      this.product = null
      this.supplierPrice = ''
      this.$emit('close')
    }
  }
}
</script>

<style>
</style>
